import React, { useEffect, useState } from "react";
import ImageGallery from "react-image-gallery";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getContent } from "../../../../utils/main";
import * as Icon from "react-bootstrap-icons";

export const LeftPart = ({ section }) => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const content = useSelector((state) => state.mainSlice.content);
  const [galleryLoading, setGalleryLoading] = useState(true);
  const [images, setImages] = useState([]);
  const params = useParams();

  useEffect(() => {
    setGalleryLoading(true);
    var localImages = [];
    for (var i = 0; i < section.images.length; i++) {
      localImages.push({
        original: process.env.REACT_APP_API_URL + section.images[i].src,
        thumbnail: process.env.REACT_APP_API_URL + section.images[i].src_thumb,
        description:
          lang === "en"
            ? section.images[i].name_en
            : lang === "ru"
            ? section.images[i].name_ru
            : section.images[i].name_tm,
      });
    }
    setImages([...[], ...localImages]);
    setGalleryLoading(false);
  }, [params, lang]);

  return (
    <div className="col-lg-9 col-md-12 col-sm-12 col-xs-12">
      <h4 className="section-header">
        <Link to="/welcome" className="text-green">
          {getContent(content, "Welcome to Turkmenistan!", lang)}
        </Link>
        <Icon.ChevronRight className="mx-2 fs-5 text-green" />
        {lang === "en"
          ? section.name_en
          : lang === "ru"
          ? section.name_ru
          : section.name_tm}
      </h4>
      <div
        dangerouslySetInnerHTML={{
          __html:
            lang === "en"
              ? section.content_en
              : lang === "ru"
              ? section.content_ru
              : section.content_tm,
        }}
      ></div>
      {galleryLoading === true ? (
        "Loading..."
      ) : section.images !== null && section.images.length !== 0 ? (
        <div className="gallery mt-5">
          <ImageGallery items={images} />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
